import React, { useState } from 'react';

interface CustomerEditModalProps {
  customer: any;
  onSave: (id: string, data: any) => void;
  onCancel: () => void;
  token: string;
}

const CustomerEditModal: React.FC<CustomerEditModalProps> = ({ customer, onSave, onCancel, token }) => {
  const [formData, setFormData] = useState({
    first_name: customer.first_name || '',
    surname: customer.surname || '',
    email: customer.email || '',
    mobile_tel: customer.mobile_tel || '',
    company_name: customer.company_name || '',
    customer_type: customer.customer_type || 'domestic',
    postcode: customer.postcode || '',
    address: customer.address || '',
    address_line1: (customer.address || '').split('\n')[0] || '',
    address_line2: (customer.address || '').split('\n')[1] || '',
    address_city: (customer.address || '').split('\n')[2] || '',
    address_county: (customer.address || '').split('\n')[3] || ''
  });
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`/api/customers/${customer.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          ...formData,
          address: [formData.address_line1, formData.address_line2, formData.address_city, formData.address_county].filter(Boolean).join('\n'),
          postcode: formData.postcode
        })
      });
      
      if (res.ok) {
        onSave(customer.id, formData);
      } else {
        alert('Failed to update customer');
      }
    } catch (err) {
      alert('Error updating customer');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overflow: 'auto' }}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', width: '500px', maxWidth: '95%', maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>Edit Customer</h2>
          <button onClick={onCancel} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>✕</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>First Name *</label>
            <input type="text" value={formData.first_name} onChange={e => setFormData({...formData, first_name: e.target.value})} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Surname *</label>
            <input type="text" value={formData.surname} onChange={e => setFormData({...formData, surname: e.target.value})} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Email</label>
            <input type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Phone</label>
            <input type="tel" value={formData.mobile_tel} onChange={e => setFormData({...formData, mobile_tel: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Company Name</label>
            <input type="text" value={formData.company_name} onChange={e => setFormData({...formData, company_name: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Customer Type</label>
            <select value={formData.customer_type} onChange={e => setFormData({...formData, customer_type: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }}>
              <option value="domestic">Domestic (Home)</option>
              <option value="business">Business (Commercial)</option>
            </select>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Address Line 1 *</label>
            <input type="text" value={formData.address_line1} onChange={e => setFormData({...formData, address_line1: e.target.value})} placeholder="House number and street" style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Address Line 2</label>
            <input type="text" value={formData.address_line2} onChange={e => setFormData({...formData, address_line2: e.target.value})} placeholder="Area or dependent locality" style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Town / City</label>
            <input type="text" value={formData.address_city} onChange={e => setFormData({...formData, address_city: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>County</label>
            <input type="text" value={formData.address_county} onChange={e => setFormData({...formData, address_county: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Postcode</label>
            <input type="text" value={formData.postcode} onChange={e => setFormData({...formData, postcode: e.target.value})} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button type="submit" disabled={loading} style={{ flex: 1, padding: '12px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' }}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
            <button type="button" onClick={onCancel} style={{ flex: 1, padding: '12px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' }}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerEditModal;
